/**
 * Utilitaires pour la gestion des tokens CSRF
 */

/**
 * Récupère le token CSRF depuis le DOM ou les cookies
 * @returns {string|null} Le token CSRF ou null si non trouvé
 */
export function getCSRFToken() {
    // Essayer de récupérer depuis le meta tag d'abord
    const metaToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (metaToken) {
        return metaToken;
    }
    
    // Sinon, essayer de récupérer depuis les cookies
    const cookieToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('csrftoken='))
        ?.split('=')[1];
    
    return cookieToken || null;
}

/**
 * Vérifie si un token CSRF est disponible
 * @returns {boolean} True si un token est disponible
 */
export function hasCSRFToken() {
    return getCSRFToken() !== null;
}

/**
 * Ajoute le token CSRF aux headers d'une requête
 * @param {Object} headers - Les headers de la requête
 * @returns {Object} Les headers avec le token CSRF ajouté
 */
export function addCSRFTokenToHeaders(headers = {}) {
    const token = getCSRFToken();
    if (token) {
        return {
            ...headers,
            'X-CSRFToken': token
        };
    }
    return headers;
}

/**
 * Configure les intercepteurs Axios pour ajouter automatiquement le token CSRF
 * @param {Object} axios - L'instance Axios à configurer
 */
export function setupCSRFInterceptor(axios) {
    axios.interceptors.request.use(function (config) {
        // Ajouter le token CSRF pour les méthodes qui modifient les données
        if (['post', 'put', 'delete', 'patch'].includes(config.method?.toLowerCase())) {
            const token = getCSRFToken();
            if (token) {
                config.headers['X-CSRFToken'] = token;
            }
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
} 